// Curated AutoCycle processing recipes — structured data, NO executable code.
//
// A recipe describes the RealityScan + Blender pipeline a job runs. It is the safe
// replacement for the standalone app's user-authored, eval'd "callback" templates.
// Per-job tweaks (control set, source, label) are layered on top at submit time;
// the recipe itself is a vetted, admin-managed preset.
//
// Seeded from the real standalone presets in ~/Projects/autocycle/presets/.
// In Phase 2 these move to Firestore (admin-managed); the shape stays the same.

// Marker control sets — which Ground Control Point set + reconstruction region a job
// uses. Booth rigs have a fixed, pre-measured set; the field/marker-plate option
// (Phase 4) generates these per-capture via the autoframe engine.
export const CONTROL_SETS = [
  { id: "body", label: "Body" },
  { id: "head", label: "Head" },
  { id: "compact_plate", label: "Compact Plate" },
  { id: "traveling_tabletop", label: "Traveling Tabletop" },
  // Phase 4: { id: "field_auto", label: "Field — marker plates (auto)", auto: true },
];

export const MODEL_QUALITY = {
  high: "High",
  normal: "Normal",
  preview: "Preview",
};

export const RAW_MODES = {
  original: "Original (no conversion)",
  rawToJpg: "RAW → JPG",
};

export const RECIPES = [
  {
    id: "high_1m_100k_glb_usdz",
    name: "High · 1M + 100K · GLB + USDZ",
    description:
      "Full-detail mesh, decimated to 1M and 100K triangles, textured and exported to GLB and USDZ. The studio default.",
    quality: "high",
    rawMode: "original",
    markers: "Circ Dual-Ring 12-bit",
    variants: [
      { name: "1M", tris: "1,000,000", texture: "16K", formats: ["OBJ", "GLB", "USDZ"] },
      { name: "100K", tris: "100,000", texture: "4K", formats: ["OBJ", "GLB", "USDZ"] },
    ],
  },
  {
    id: "normal_1m_100k_glb_usdz",
    name: "Normal · 1M + 100K · GLB + USDZ",
    description:
      "Same outputs as the High recipe but a normal-quality base mesh — faster, lighter on the GPU.",
    quality: "normal",
    rawMode: "original",
    markers: "Circ Dual-Ring 12-bit",
    variants: [
      { name: "1M", tris: "1,000,000", texture: "16K", formats: ["OBJ", "GLB", "USDZ"] },
      { name: "100K", tris: "100,000", texture: "4K", formats: ["OBJ", "GLB", "USDZ"] },
    ],
  },
  {
    id: "high_1m_50k_smoothed_glb",
    name: "High · 1M + 50K smoothed · GLB",
    description:
      "Full-detail base, smoothed decimations at 1M and 50K, exported to GLB only. Good for clean web delivery.",
    quality: "high",
    rawMode: "original",
    markers: "Circ Dual-Ring 12-bit",
    variants: [
      { name: "1M", tris: "1,000,000", texture: "16K", formats: ["OBJ", "GLB"], smoothed: true },
      { name: "50K", tris: "50,000", texture: "2K", formats: ["OBJ", "GLB"], smoothed: true },
    ],
  },
];

export const getRecipe = (id) => RECIPES.find((r) => r.id === id);
export const getControlSet = (id) => CONTROL_SETS.find((c) => c.id === id);
